import { createRoute, redirect } from "@tanstack/react-router"

import { ProjectSelectorModel } from "@/components/ProjectSelector/ProjectSelectorModel.ts"
import { batchInfo } from "@/lib/apiClient/client.ts"
import { withGlobalLoader } from "@/lib/context.ts"
import { appendTokenParams, isSubdomain } from "@/lib/url.ts"
import { LoginScene } from "@/routes/auth/LoginScene.tsx"
import { HomeScene } from "@/routes/home/HomeScene.tsx"
import { Navigator } from "@/routes/Navigator.ts"
import { OrgRoute, ReservedRoute } from "@/routes/root/RootRoute.tsx"


export const LoginRoute = createRoute({
  path: "login",
  component: () => <LoginScene />,
  beforeLoad: ({ context }) => {
    if (context.authController.authenticatedUser() != null) {
      redirectOnAuthenticated()
    }

    // If once was logged it - try silent redirect
    if (context.authController.isExpired()) {
      context.authController.signIn(null)
    }
  },

  getParentRoute: () => ReservedRoute,
})

export const LoginResponseRoute = createRoute({
  path: "login-response",
  beforeLoad: ({ context }) => {
    context.authController.onAuthRedirected()
    redirectOnAuthenticated()
  },
  getParentRoute: () => ReservedRoute,
})

export const HomeRouteIndex = createRoute({
  path: "/",
  component: () => <HomeScene />,

  loader: async ({ context }) => {
    const [projects, favoriteProjects] = await withGlobalLoader(context, Promise.all([
      context.queries.listProjectsV2(batchInfo(ProjectSelectorModel.getBatchSize())),
      context.queries.favoriteProjects(),
    ]))

    return { projects, favoriteProjects }
  },

  getParentRoute: () => OrgRoute,
})

export const AuthorizePreviewRoute = createRoute({
  path: "authorize/preview",

  beforeLoad: async ({ context, location }) => {
    const previewUrl = new URLSearchParams(location.search).get("redirect")
    if (!previewUrl) {
      throw redirect(Navigator.orgHome(context.orgId, { replace: true }))
    }

    // If the redirect URL is not a subdomain of the current one, redirect to org home
    if (!isSubdomain(previewUrl)) {
      throw redirect(Navigator.orgHome(context.orgId, { replace: true }))
    }

    const token = await withGlobalLoader(context, context.authController.tokenSource.token())

    // Redirect to the preview URL with the token
    window.location.href = appendTokenParams(previewUrl, token.accessToken, token.expiresAt)
  },

  getParentRoute: () => OrgRoute,
})

function redirectOnAuthenticated() {
  const href = localStorage.getItem("redirect")
  if (!href) {
    window.location.href = "/"
    return
  }

  localStorage.removeItem("redirect")
  throw redirect({ href })
}
